import Big from "big.js";

/**
 * Convert any value safely to Big
 */
export const toBig = (value) => {
  try {
    return new Big(value || 0);
  } catch {
    return new Big(0);
  }
};

/**
 * Addition
 */
export const bigAdd = (a, b) => {
  return toBig(a).plus(toBig(b));
};

/**
 * Subtraction
 */
export const bigSub = (a, b) => {
  return toBig(a).minus(toBig(b));
};

/**
 * Multiplication
 */
export const bigMul = (a, b) => {
  return toBig(a).times(toBig(b));
};

/**
 * Division
 */
export const bigDiv = (a, b) => {
  if (!b) return new Big(0);
  return toBig(a).div(toBig(b));
};

/**
 * Calculate percentage
 * Example: tax = percent(amount, 5)
 */
export const bigPercent = (value, percent) => {
  return bigMul(value, percent).div(100);
};

/**
 * Sum array of values safely
 */
export const sumBig = (arr = [], selector = (x) => x) => {
  return arr.reduce((sum, item) => {
    return sum.plus(toBig(selector(item)));
  }, new Big(0));
};

/**
 * Convert Big to string (for DECIMAL DB)
 */
export const bigToString = (value) => {
  return toBig(value).toString();
};

/**
 * Display helper (2 decimals for UI)
 */
export const bigToFixed2 = (value) => {
  return toBig(value).toFixed(2);
};